import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function preloadHero() {
  if (typeof document === 'undefined') return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=640&auto=format&fit=crop';
  link.setAttribute('imagesrcset', 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=480&auto=format&fit=crop 480w, https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=800&auto=format&fit=crop 800w, https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=1200&auto=format&fit=crop 1200w');
  link.setAttribute('imagesizes', '(max-width: 1024px) 100vw, 50vw');
  link.setAttribute('fetchpriority', 'high');
  document.head.appendChild(link);
})();
render(<App data-id="element-164" />, document.getElementById('root'));